import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { getPartner } from '../../../../../../lib/access.es6';
import ButtonInc from '../../../../../../shared-ui/ButtonInc';
import MemberBenefitsTable from '../../shared/Components/MemberBenefitsTable';
import PolicyInfoHeader from '../../shared/Components/PolicyInfoHeader';
import AmendmentPageHeader from '../../shared/Components/AmendmentPageHeader';

const useStyles = makeStyles(() => ({
  container: {
    padding: '20px'
  },
  navigationButtons: {
    marginTop: '30px',
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '10px'
  }
}));

const MemberSelectionScreen = (props) => {
  const { policy, members, originalMembers, onManageBenefits, onCancel, onContinue } = props;
  const classes = useStyles();
  const currencyCode = getPartner().country.currency_code;

  // Categorize members
  const nuclearMembers = members.filter(m =>
    ['Principal', 'Spouse', 'Child'].includes(m.relationship)
  );
  const parentMembers = members.filter(m =>
    ['Father', 'Mother', 'Father In Law', 'Mother In Law', 'Parent', 'Parent_In_Law'].includes(m.relationship)
  );
  const extendedMembers = members.filter(m =>
    !['Principal', 'Spouse', 'Child', 'Father', 'Mother', 'Father In Law', 'Mother In Law', 'Parent', 'Parent_In_Law'].includes(m.relationship)
  );

  // Calculate premiums
  const currentTotalPremium = originalMembers.reduce((sum, m) => sum + (m.premium_amount_in_cents || 0), 0);
  const newTotalPremium = members.reduce((sum, m) => sum + (m.premium_amount_in_cents || 0), 0);
  const premiumDifference = newTotalPremium - currentTotalPremium;
  const hasChanges = premiumDifference !== 0;

  const renderActionButton = (member) => (
    <ButtonInc
      style={{ cursor: 'pointer' }}
      onClick={() => onManageBenefits(member)}
    >
      Manage Benefits
    </ButtonInc>
  );

  return (
    <div className={classes.container}>
      {/* Header Section with Back Button */}
      <AmendmentPageHeader
        title="Manage Benefits"
        subtitle="Add or remove optional benefits for each member. Premiums update in real-time."
        onBack={onCancel}
      />

      {/* Policy Information */}
      <PolicyInfoHeader policy={policy} />

      {/* Premium Comparison Display */}
      <div style={{
        backgroundColor: '#f5f5f5',
        border: '1px solid #ddd',
        borderRadius: '8px',
        padding: '20px',
        marginBottom: '20px'
      }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: hasChanges ? '15px' : '0' }}>
          <span style={{ fontSize: '16px', fontWeight: '500' }}>Current Total Premium:</span>
          <span style={{ fontSize: '18px', fontWeight: '600', color: '#666' }}>
            {currencyCode} {(currentTotalPremium / 100).toFixed(2)}
          </span>
        </div>
        {hasChanges && (
          <>
            <div style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              margin: '10px 0',
              fontSize: '18px',
              color: '#666'
            }}>
              →
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px' }}>
              <span style={{ fontSize: '18px', fontWeight: '600' }}>New Total Premium:</span>
              <span style={{ fontSize: '22px', fontWeight: 'bold', color: '#032A37' }}>
                {currencyCode} {(newTotalPremium / 100).toFixed(2)}
              </span>
            </div>
            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              paddingTop: '15px',
              borderTop: '1px solid #ddd'
            }}>
              <span style={{ fontSize: '16px', fontWeight: '600' }}>
                Premium {premiumDifference > 0 ? 'Increase' : 'Decrease'}:
              </span>
              <span style={{
                fontSize: '18px',
                fontWeight: 'bold',
                color: premiumDifference > 0 ? '#28a745' : '#dc3545'
              }}>
                {premiumDifference > 0 ? '+' : ''}{currencyCode} {(Math.abs(premiumDifference) / 100).toFixed(2)}
              </span>
            </div>
          </>
        )}
      </div>

      <MemberBenefitsTable
        members={nuclearMembers}
        title="Nuclear Members"
        renderActionButton={renderActionButton}
      />

      <MemberBenefitsTable
        members={parentMembers}
        title="Parent Members"
        renderActionButton={renderActionButton}
      />

      <MemberBenefitsTable
        members={extendedMembers}
        title="Extended Members"
        renderActionButton={renderActionButton}
      />

      <div className={classes.navigationButtons}>
        <ButtonInc onClick={onContinue}>
          Continue to Summary
        </ButtonInc>
      </div>
    </div>
  );
};

export default MemberSelectionScreen;
